import { render, staticRenderFns } from "./EmailControlTab.vue?vue&type=template&id=5ed5e99e&scoped=true"
import script from "./EmailControlTab.vue?vue&type=script&lang=js"
export * from "./EmailControlTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5e99e",
  null
  
)

export default component.exports